// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3640":"6ec23dbe","4268":"fa476c07","5999":"45aeb114","9985":"31d6cfe0"}[chunkId] + ".chunk.css";
};